<ng-container *ngIf="element.type === 'text'">
  <div [class.can-edit]="!element.fixedContent" [class.exclude-from-pdf]="excludeFromPdf()" class="text-wrapper">
    <div
      [style.text-align]="element.justify ?? 'left'"
      [class.editable-hover]="!element.fixedContent"
      class="text-content-wrapper"
    >
      <div
        *ngIf="element.heading != null"
        [style.color]="getTextHeadingColor()"
        [innerHTML]="getSafeHtml(getTextHeading())"
        class="text-heading"
      ></div>
      <div
        *ngIf="element.content != null"
        [innerHTML]="getSafeHtml(getTextContent())"
        [class.report-title]="element.variant === 'report-title'"
        class="text-content"
      ></div>
    </div>

    <div *ngIf="!element.fixedContent" class="text-edit-overlay">
      <button mat-icon-button class="text-edit-button" title="Edit text" (click)="onEditText()">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="element.type === 'page-header'">
  <ng-container *ngIf="getPageHeader() as pageHeader">
    <div class="overlay-wrapper">
      <div class="page-header overlay-content-wrapper" [style.color]="pageHeader.color">
        <div class="header-title">{{ pageHeader.header }}</div>
        <div class="header-meta">
          <div *ngIf="pageHeader.date" class="meta-item">
            <span class="meta-label">Date</span>
            <span class="meta-value">{{ pageHeader.date }}</span>
          </div>
          <div *ngIf="pageHeader.sport" class="meta-item">
            <span class="meta-label">Sport</span>
            <span class="meta-value">{{ pageHeader.sport }}</span>
          </div>
          <div *ngIf="pageHeader.athlete" class="meta-item">
            <span class="meta-label">Athlete</span>
            <span class="meta-value">{{ pageHeader.athlete }}</span>
          </div>
          <div *ngIf="pageHeader.coach" class="meta-item">
            <span class="meta-label">Coach</span>
            <span class="meta-value">{{ pageHeader.coach }}</span>
          </div>
          <div *ngIf="pageHeader.testDisplayId" class="meta-item">
            <span class="meta-label">Test ID</span>
            <span class="meta-value">{{ pageHeader.testDisplayId }}</span>
          </div>
          <div *ngIf="pageHeader.testType" class="meta-item">
            <span class="meta-label">Test Type</span>
            <span class="meta-value">{{ pageHeader.testType }}</span>
          </div>
        </div>
      </div>

      <div class="edit-overlay">
        <button mat-icon-button class="overlay-edit-button" title="Edit page title" (click)="onEditPageTitle()">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="element.type === 'test-info'">
  <div class="overlay-wrapper">
    <table class="test-info overlay-content-wrapper">
      <tr class="test-info__row" *ngFor="let item of getTestInfo() | keyvalue: preserveOrder">
        <td
          class="test-info__cell test-info__cell--header"
          [style.color]="reportConfig.template?.theme?.colors?.primary || 'rgba(34, 34, 34)'"
        >
          {{ item.value.name }}
        </td>
        <td class="test-info__cell test-info__cell--data" [attr.data-key]="item.key">{{ item.value.value }}</td>
      </tr>
    </table>

    <div class="edit-overlay">
      <button mat-icon-button class="overlay-edit-button" title="Edit page title" (click)="onEditTestInfoCover()">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="element.type === 'table-composition'">
  <table class="table-composition" [style.border]="'1px solid ' + getSecondaryColor()">
    <tr class="table-composition__row" *ngFor="let item of getTableComposition() | keyvalue: preserveOrder">
      <td
        class="table-composition__cell table-composition__cell--header"
        [style.color]="reportConfig.template?.theme?.colors?.primary || 'rgba(34, 34, 34)'"
      >
        {{ item.value.name }}
      </td>
      <td class="table-composition__cell table-composition__cell--data" [attr.data-key]="item.key">
        {{ item.value.value }}
      </td>
    </tr>
  </table>
</ng-container>

<ng-container *ngIf="element.type === 'org-info'">
  <div class="overlay-wrapper">
    <div class="text-org-info overlay-content-wrapper" [innerHTML]="getSafeHtml(getOrgInfo())"></div>

    <div class="edit-overlay">
      <button mat-icon-button class="overlay-edit-button" title="Edit page title" (click)="onEditOrgInfo()">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="element.type === 'traffic-lights'">
  <div
    *ngIf="typicalErrorList.value.length > 0"
    [class.typical-error--vertical]="element.variant === 'vertical'"
    class="typical-error"
  >
    <div
      class="typical-error__item tile o-flex o-flex--justify-space-between u-margin-5"
      *ngFor="let item of (typicalErrorList.$ | async)!"
    >
      <div class="o-flex o-flex--column o-flex--justify-center">
        <div>
          <span class="typical-error__name u-font-weight-400 text-color">{{ item.name }}</span>
        </div>
        <div>
          <span class="typical-error__value u-font-weight-400 disabled-text">± {{ item.value }} {{ item.unit }}</span>
        </div>
      </div>
      <div class="o-flex o-flex--justify-center o-flex--align-items-center">
        <mat-icon
          class="typical-error--dimension"
          *ngIf="item.color === TYPICAL_ERROR_ENUM.GREEN"
          svgIcon="success-smile"
        ></mat-icon>
        <mat-icon
          class="typical-error--dimension"
          *ngIf="item.color === TYPICAL_ERROR_ENUM.YELLOW"
          svgIcon="warning-smile"
        ></mat-icon>
        <mat-icon
          class="typical-error--dimension"
          *ngIf="item.color === TYPICAL_ERROR_ENUM.RED"
          svgIcon="error-smile"
        ></mat-icon>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="element.type === 'raw-test-data'">
  <div class="overlay-wrapper">
    <div *ngIf="measuredValues.value.length > 0" class="raw-test-data overlay-content-wrapper">
      <div class="test-data-table-layout">
        <div
          *ngIf="element.heading != null"
          [style.color]="getTextHeadingColor()"
          [innerHTML]="getSafeHtml(getTextHeading())"
          class="text-heading"
        ></div>

        <table
          class="table raw-test-data-table"
          [style.border]="'1px solid ' + getSecondaryColor()"
          aria-describedby="measured value"
        >
          <thead>
            <tr [style.color]="getHeadingColor()">
              <th scope="col" class="raw-test-data-table__header" [style.border]="'1px solid ' + getSecondaryColor()">
                Type
              </th>
              <th scope="col" class="raw-test-data-table__header" [style.border]="'1px solid ' + getSecondaryColor()">
                Duration
              </th>
              <th scope="col" class="raw-test-data-table__header" [style.border]="'1px solid ' + getSecondaryColor()">
                {{ isSpeed.value ? 'Average Speed' : 'Average Power' }}
              </th>
              <th scope="col" class="raw-test-data-table__header" [style.border]="'1px solid ' + getSecondaryColor()">
                Additional Value
              </th>
            </tr>
          </thead>
          <tr *ngFor="let measuredValue of measuredValues.value">
            <td [innerHTML]="measuredValue.type" [style.border]="'1px solid ' + getSecondaryColor()"></td>
            <td [style.border]="'1px solid ' + getSecondaryColor()">{{ measuredValue.duration }}</td>
            <td [style.border]="'1px solid ' + getSecondaryColor()">
              {{
                isSpeed.value
                  ? measuredValue.speed
                    ? measuredValue.speed + 'm/s'
                    : ''
                  : measuredValue.power
                    ? measuredValue.power + 'W'
                    : ''
              }}
            </td>
            <td
              [innerHTML]="measuredValue.additionalValueString"
              [style.border]="'1px solid ' + getSecondaryColor()"
            ></td>
          </tr>
        </table>

        <div *ngIf="element.content != null" [innerHTML]="getSafeHtml(getTextContent())" class="text-content"></div>
      </div>
    </div>

    <div class="edit-overlay">
      <button mat-icon-button class="overlay-edit-button" title="Edit page title" (click)="onEditText()">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="element.type === 'lactate-measured'">
  <div class="overlay-wrapper">
    <div class="overlay-content-wrapper" [class.overlay-content-wrapper--full]="element.variant !== 'fixed'">
      <div
        *ngIf="element.heading != null"
        [style.color]="getTextHeadingColor()"
        [innerHTML]="getSafeHtml(getTextHeading())"
        class="text-heading"
      ></div>

      <table id="rawTestDataTable" border="0" class="lactate-raw-data-table" aria-describedby="tabel">
        <tbody>
          <tr *ngFor="let raw_data of rawTestDataTable.value.data; let isFirstRow = first; let isLastRow = last">
            <td
              *ngFor="let value of raw_data; let isLastCol = last"
              [style.border-top]="'1px solid ' + getSecondaryColor()"
              [style.border-left]="'1px solid ' + getSecondaryColor()"
              [style.border-right]="isLastCol ? '1px solid ' + getSecondaryColor() : 'none'"
              [style.border-bottom]="isLastRow ? '1px solid ' + getSecondaryColor() : 'none'"
              [style.font-weight]="isFirstRow ? 'bolder' : 'inherit'"
              [style.color]="isFirstRow ? getHeadingColor() : 'inherit'"
            >
              {{ value }}
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="element.content != null" [innerHTML]="getSafeHtml(getTextContent())" class="text-content"></div>
    </div>

    <div class="edit-overlay">
      <button mat-icon-button class="overlay-edit-button" title="Edit page title" (click)="onEditText()">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="element.type === 'lactate-calculated'">
  <div class="overlay-wrapper">
    <div class="overlay-content-wrapper" [class.overlay-content-wrapper--full]="element.variant !== 'fixed'">
      <div
        *ngIf="element.heading != null"
        [style.color]="getTextHeadingColor()"
        [innerHTML]="getSafeHtml(getTextHeading())"
        class="text-heading"
      ></div>

      <table id="calculatedDataTable" border="0" class="lactate-raw-data-table" aria-describedby="tabel">
        <tbody>
          <tr *ngFor="let raw_data of calculatedDataTable.value.data; let isFirstRow = first; let isLastRow = last">
            <td
              *ngFor="let value of raw_data; let isLastCol = last"
              [style.border-top]="'1px solid ' + getSecondaryColor()"
              [style.border-left]="'1px solid ' + getSecondaryColor()"
              [style.border-right]="isLastCol ? '1px solid ' + getSecondaryColor() : 'none'"
              [style.border-bottom]="isLastRow ? '1px solid ' + getSecondaryColor() : 'none'"
              [style.font-weight]="isFirstRow ? 'bolder' : 'inherit'"
              [style.color]="isFirstRow ? getHeadingColor() : 'inherit'"
            >
              {{ value }}
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="element.content != null" [innerHTML]="getSafeHtml(getTextContent())" class="text-content"></div>
    </div>

    <div class="edit-overlay">
      <button mat-icon-button class="overlay-edit-button" title="Edit page title" (click)="onEditText()">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="element.type === 'training-zones' && trainingZoneJsonData.value.length > 0">
  <div class="overlay-wrapper">
    <div class="overlay-content-wrapper report-training-zones">
      <table style="width: 100%; margin-bottom: 12px" aria-describedby="training zone">
        <tr>
          <th scope="row" [style.color]="getTextHeadingColor()">Zone</th>
          <th scope="row" [style.color]="getTextHeadingColor()">Code</th>
          <th [colSpan]="getMaxLowUpTarget()" scope="row" [style.color]="getTextHeadingColor()">Lower</th>
          <th [colSpan]="getMaxLowUpTarget()" scope="row" [style.color]="getTextHeadingColor()">Upper</th>
          <th [colSpan]="getMaxLowUpTarget()" scope="row" [style.color]="getTextHeadingColor()">Target</th>
          <th
            [colSpan]="getMaxOutputValues(trainingZoneJsonData.value)"
            scope="row"
            [style.color]="getTextHeadingColor()"
          >
            Physiological Conditions
          </th>
        </tr>
        <tr style="visibility: collapse">
          <!-- Zone -->
          <th scope="row">&nbsp;</th>
          <!-- Code -->
          <th scope="row">&nbsp;</th>
          <!-- Lower -->
          <th scope="row">&nbsp;</th>
          <th scope="row">&nbsp;</th>
          <th scope="row">&nbsp;</th>
          <th scope="row">&nbsp;</th>
          <th scope="row">&nbsp;</th>
          <th scope="row">&nbsp;</th>
          <!-- Upper -->
          <th scope="row">&nbsp;</th>
          <th scope="row">&nbsp;</th>
          <th scope="row">&nbsp;</th>
          <th scope="row">&nbsp;</th>
          <th scope="row">&nbsp;</th>
          <th scope="row">&nbsp;</th>
          <!-- Target -->
          <th scope="row">&nbsp;</th>
          <th scope="row">&nbsp;</th>
          <th scope="row">&nbsp;</th>
          <th scope="row">&nbsp;</th>
          <th scope="row">&nbsp;</th>
          <th scope="row">&nbsp;</th>
          <!-- Output -->
          <th scope="row" [colSpan]="getMaxOutputValues(trainingZoneJsonData.value)">&nbsp;</th>
        </tr>
        <tr *ngFor="let zone of getTzbZones(); let zoneIndex = index">
          <td *ngIf="zone.name.value" [ngStyle]="firstRowCellStyle(zone)">{{ zone.name.value }}</td>
          <td *ngIf="zone.code.value">{{ zone.code.value }}</td>
          <td [colSpan]="zone.lower.colspan" *ngFor="let header of zone.lower.headers; let i = index">
            <span class="title-zone">{{ header }}</span> <br />
            <strong (input)="onRowClick($event, zoneIndex, zoneTableValueType.LOWER, i)">{{
              zone.lower.values[i]
            }}</strong
            ><br />
            <span class="title-zone">{{ zone.lower.units[i] }}</span> <br />
          </td>
          <td [colSpan]="zone.lower.colspan" *ngFor="let header of zone.upper.headers; let i = index">
            <span class="title-zone">{{ header }}</span> <br />
            <strong (input)="onRowClick($event, zoneIndex, zoneTableValueType.UPPER, i)">{{
              zone.upper.values[i]
            }}</strong
            ><br />
            <span class="title-zone">{{ zone.upper.units[i] }}</span> <br />
          </td>
          <td [colSpan]="zone.lower.colspan" *ngFor="let header of zone.target.headers; let i = index">
            <div
              *ngIf="zone.target.values[i] !== 0 && zone.target.values[i] !== '0' && zone.target.values[i] !== '00:00'"
            >
              <span class="title-zone">{{ header }}</span> <br />
              <strong (input)="onRowClick($event, zoneIndex, zoneTableValueType.TARGET, i)">{{
                zone.target.values[i]
              }}</strong
              ><br />
              <span class="title-zone">{{ zone.target.units[i] }}</span> <br />
            </div>
          </td>
          <td [style.width]="getWidthOutputValue()" *ngFor="let header of zone.output_values.headers; let i = index">
            <span class="title-zone">{{ header }}</span> <br />
            <strong (input)="onRowClick($event, zoneIndex, zoneTableValueType.OUTPUT, i)">{{
              zone.output_values.values[i]
            }}</strong
            ><br />
            <span class="title-zone">{{ zone.output_values.units[i] }}</span>
            <br />
          </td>
        </tr>
      </table>

      <div
        *ngIf="element.heading != null"
        [style.color]="getTextHeadingColor()"
        [innerHTML]="getSafeHtml(getTextHeading())"
        class="text-heading"
      ></div>

      <div *ngIf="element.content != null" [innerHTML]="getSafeHtml(getTextContent())" class="text-content"></div>
    </div>

    <div class="edit-overlay">
      <button mat-icon-button class="overlay-edit-button" title="Edit page title" (click)="onEditTZB()">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>
</ng-container>
